export default {
  en: {
    attachment: 'Attachment',
    download: 'Download',
    addAttachment: 'Add Attachment',
    upload: 'Upload',
    clear: 'Clear',
    save: 'Save Change',
    cancel: 'Cancel',
    success: 'Success',
    editFileName: 'Edit File Name',
    fileName: 'File Name',
    uploadSuccessMessage: 'Upload Attachment Success',
    editNameSuccessMessage: 'Edit File Name Success',
    pleaseEnterFileName: 'Please enter file name',
    confirmDeleteFileMessage: 'Confirm to delete <strong>{attachFile}</strong> ?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel'
  },
  th: {
    attachment: 'ไฟล์แนบ',
    download: 'ดาวน์โหลด',
    addAttachment: 'เพิ่มไฟล์',
    upload: 'อัพโหลด',
    clear: 'ล้างข้อมูล',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    success: 'สำเร็จ',
    editFileName: 'แก้ไขชื่อไฟล์',
    fileName: 'ชื่อไฟล์',
    uploadSuccessMessage: 'อัพโหลดไฟล์สำเร็จ',
    editNameSuccessMessage: 'แก้ไขชื่อไฟล์สำเร็จ',
    pleaseEnterFileName: 'กรุณาใส่ชื่อไฟล์',
    confirmDeleteFileMessage: 'กรุณายืนยันการลบ <strong>{attachFile}</strong> ?',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก'
  }
}
